import Link from "next/link";
import styles from "gui/card/card.module.css";
import { Cell } from "gui/grid/cell";
import { Icon } from "gui/icon/icon";

export interface CardProps {
  icon: string;
  title: string;
  subtitle: string;
  href: string;
  as?: string;
}

export const Card: React.FC<CardProps> = (props) => {
  return (
    <Cell as="article" span6="sm" span4="lg">
      <Link href={props.href} as={props.as}>
        <a className={styles.card}>
          <h3 className={styles.title} title={props.title}>
            <Icon icon={props.icon} />
            {props.title}
          </h3>
          <p className={styles.subtitle}>{props.subtitle}</p>
        </a>
      </Link>
    </Cell>
  );
};
